import { render, staticRenderFns } from "./EventMarketingEditForm.vue?vue&type=template&id=3fc07b8a"
import script from "./EventMarketingEditForm.vue?vue&type=script&lang=js"
export * from "./EventMarketingEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports